const UploadErrorCode = new Map<string, string>([
  ['CORRUPT_IMAGE', 'corrupted_photos'],
  ['UNSUPPORTED_FILE_TYPE', 'unsupported_extension'],
]);

export default UploadErrorCode;
